module.exports = __webpack_public_path__ + "media/images/backgrounds/how_to2-c0463f8b893bc17bf086dcf69ca5aa2b.svg";